/**
 * Handles the response from game form submit (create/update).
 * Invokes the appropriate callback based on response status and JSON body.
 *
 * @param {{ ok: boolean }} response - Fetch response (or object with .ok)
 * @param {{ alert?: { text: string, type: string }, game?: object } | null} json - Parsed JSON or null
 * @param {{ setLoading: (boolean) => void, setAlert: (object|null) => void, onUpdate: (object) => void, onClose: () => void }} callbacks
 */
export function handleGameFormSubmitResponse(response, json, callbacks) {
  const { setLoading, setAlert, onUpdate, onClose } = callbacks

  if (!response.ok && json?.alert) {
    setLoading(false)
    setAlert(json.alert)
    return
  }
  if (!response.ok) {
    setLoading(false)
    setAlert({ text: 'Something went wrong. Please try again.', type: 'error' })
    return
  }
  if (json?.alert) {
    setLoading(false)
    setAlert(json.alert)
  } else if (json?.game) {
    onUpdate(json)
  } else {
    onClose()
  }
}

/**
 * Handles submit errors (network or JSON parse failure).
 *
 * @param {Error} err
 * @param {{ setLoading: (boolean) => void, setAlert: (object) => void }} callbacks
 */
export function handleGameFormSubmitError(err, callbacks) {
  console.error('Game form submit error:', err)
  callbacks.setLoading(false)
  callbacks.setAlert({ text: 'Something went wrong. Please try again.', type: 'error' })
}
